import { IconButton } from '@creditornot/cb-button';
import { CompassArrowFilled, Minus, Plus } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { useMap } from 'react-map-gl';
import styled, { css } from 'styled-components';

import { Bounds, fitBoundsOptions } from './mapUtils/mapUtils';

type Props = {
  position: 'top-left' | 'top-right';
  bounds: Bounds;
};

const Root = styled.div<{ position: 'top-left' | 'top-right' }>`
  position: absolute;
  top: 12px;
  ${({ position }) =>
    position === 'top-left'
      ? css`
          left: 12px;
        `
      : css`
          right: 12px;
        `}
`;

const ButtonContainer = styled.div`
  background: ${cbSemanticCssVars.surfaceMain}; /* make buttons non-transparent against the map */
  border-radius: 12px;
  margin-block-start: 8px;

  &:first-child {
    margin-block-start: 0;
  }
`;

const StyledIconButton = styled(IconButton).attrs({
  variant: 'neutral',
  background: 'transparent',
  size: 'tiny',
  type: 'button',
})`
  display: block;
`;

const MapZoomButtons = ({ position, bounds }: Props) => {
  const { current: map } = useMap();

  if (!map) {
    return null;
  }

  return (
    <Root position={position}>
      <ButtonContainer>
        <StyledIconButton onClick={() => map.zoomIn()}>
          <Plus />
        </StyledIconButton>
      </ButtonContainer>
      <ButtonContainer>
        <StyledIconButton onClick={() => map.zoomOut()}>
          <Minus />
        </StyledIconButton>
      </ButtonContainer>
      <ButtonContainer>
        <StyledIconButton onClick={() => map.fitBounds(bounds, { ...fitBoundsOptions, linear: true })}>
          <CompassArrowFilled />
        </StyledIconButton>
      </ButtonContainer>
    </Root>
  );
};

export default MapZoomButtons;
